export default {
  admin: 'admin',
  manager: 'manager',
  doctor: 'doctor',
  user: 'user'
}



// WEBPACK FOOTER //
// ./src/utils/roleTypes.js